import {
  get,
} from '../../api';

export const FETCH_PERMISSIONS_START = 'FETCH_GET_PERMISSIONS';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAIL = 'FETCH_PERMISSIONS_FAIL';

const fetchGetPermissionsStart = () => ({
  type: FETCH_PERMISSIONS_START
});

const fetchGetPermissionsSuccess = (data) => ({
  type: FETCH_PERMISSIONS_SUCCESS,
  payload: data
});

const fetchGetPermissionsFail = (err) => ({
  type: FETCH_PERMISSIONS_FAIL,
  payload: err
});

export const fetchGetPermissions = () => async (dispatch) => {
  dispatch(fetchGetPermissionsStart());
  try {
    const result = await get('/admins/permissions/all');
    dispatch(fetchGetPermissionsSuccess(result.data));
  } catch (e) {
    dispatch(fetchGetPermissionsFail(e));
  }
};

export const FETCH_PERMISSION_VALUE_TYPES_START = 'FETCH_PERMISSION_VALUE_TYPES_START';
export const FETCH_PERMISSION_VALUE_TYPES_SUCCESS = 'FETCH_PERMISSION_VALUE_TYPES_SUCCESS';
export const FETCH_PERMISSION_VALUE_TYPES_FAIL = 'FETCH_PERMISSION_VALUE_TYPES_FAIL';

const fetchGetPermissionValueTypesStart = () => ({
  type: FETCH_PERMISSION_VALUE_TYPES_START
});

const fetchGetPermissionValueTypesSuccess = (data) => ({
  type: FETCH_PERMISSION_VALUE_TYPES_SUCCESS,
  payload: data
});

const fetchGetPermissionValueTypesFail = (err) => ({
  type: FETCH_PERMISSION_VALUE_TYPES_FAIL,
  payload: err
});

/**
 * Каталог прав, которые выдаются значением, а не флагом.
 * Ответ вида { 'admins.modules': 'string[]', 'pages.scope': 'number[]' }:
 * ключей, которых в нём нет, это не касается - они булевы.
 */
export const fetchGetPermissionValueTypes = () => async (dispatch) => {
  dispatch(fetchGetPermissionValueTypesStart());
  try {
    const result = await get('/admins/permissions/value-types');
    dispatch(fetchGetPermissionValueTypesSuccess(result.data));
  } catch (e) {
    dispatch(fetchGetPermissionValueTypesFail(e));
  }
};
